import React from 'react'

import HeroEditorialMolecule  from '@/molecules/Heroes/HeroEditorial'

const HeroEditorial = (props) => (
  <HeroEditorialMolecule {...props} />
)

export default HeroEditorial
